'use client'

import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Image from 'next/image'
import { FC, ReactNode } from 'react'

import TitleAndParagraph from '@/components/TitleAndParagraph'
import TwoColumnLayout, { ColumnWrapOrder } from '@/components/TwoColumnLayout'

const CaseStudyChallenge: FC<{ paragraph: ReactNode; imageSrc: string }> = ({
    paragraph,
    imageSrc,
}) => {
    const { smScreen } = useDevice()
    return (
        <Box>
            <TwoColumnLayout
                leftCol={6}
                rightCol={5}
                columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}
            >
                <TitleAndParagraph title={`Challenge`} paragraph={paragraph} />
                <Box sx={{ display: 'flex' }}>
                    <Box
                        sx={{
                            width: '100%',
                            height: '0',
                            paddingBottom: '100%',
                            position: 'relative',
                            img: {
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                top: 0,
                                bottom: 0,
                                ...(smScreen
                                    ? {
                                          width: '100%',
                                          height: '100%',
                                      }
                                    : {}),
                            },
                        }}
                    >
                        <Image width={486} height={526} src={imageSrc} alt={'problem'} />
                    </Box>
                </Box>
            </TwoColumnLayout>
        </Box>
    )
}

export default CaseStudyChallenge
